import template from './users.html';
import controller from './users.controller';
import './users.scss';

let usersComponent = {
  restrict: 'E',
  bindings: {
  	acl: '=',
    hasACL:'='
  },
  template,
  controller
};

export default usersComponent;


// WEBPACK FOOTER //
// ./client/app/components/users/users.component.js